import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  CompanyItem,
  CompanyRegisterRequest,
  CreateCompanyRequest,
  PagedCompaniesResponse,
  UpdateCompanyRequest,
  AdjustWalletRequest,
} from '../models/company.models';
import {
  CompanyPricingResponse,
  UpdateCompanyPricingRequest,
} from '../models/company-pricing.models';
import { CompaniesApiService } from './companies-api.service';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  private readonly companiesApiService = inject(CompaniesApiService);

  getCompanies(
    pageNumber: number = 1,
    pageSize: number = 20,
    search?: string,
    isActive?: boolean,
  ): Observable<ApiResponse<PagedCompaniesResponse>> {
    return this.companiesApiService.getCompanies(pageNumber, pageSize, search, isActive);
  }

  getCompany(companyId: number): Observable<ApiResponse<CompanyItem>> {
    return this.companiesApiService.getCompany(companyId);
  }

  createCompany(payload: CreateCompanyRequest): Observable<ApiResponse<CompanyItem>> {
    return this.companiesApiService.createCompany(payload);
  }

  updateCompany(companyId: number, payload: UpdateCompanyRequest): Observable<ApiResponse<CompanyItem>> {
    return this.companiesApiService.updateCompany(companyId, payload);
  }

  deleteCompany(companyId: number): Observable<ApiResponse<string>> {
    return this.companiesApiService.deleteCompany(companyId);
  }

  getCompanyPricing(companyId: number): Observable<ApiResponse<CompanyPricingResponse>> {
    return this.companiesApiService.getCompanyPricing(companyId);
  }

  updateCompanyPricing(companyId: number, payload: UpdateCompanyPricingRequest): Observable<ApiResponse<string>> {
    return this.companiesApiService.updateCompanyPricing(companyId, payload);
  }

  registerCompany(payload: CompanyRegisterRequest): Observable<ApiResponse<CompanyItem>> {
    return this.companiesApiService.registerCompany(payload);
  }

  adjustCompanyWallet(companyId: number, payload: AdjustWalletRequest): Observable<ApiResponse<string>> {
    return this.companiesApiService.adjustCompanyWallet(companyId, payload);
  }
}